import React from "react";
import { DeviceSensorGridProps } from "types/deviceSensor.types";
import {
  SensorGridContainer,
  SensorCell,
  SensorLabel,
  SensorValue,
} from "styles/devices/deviceSensorGrid.styles";

// Helper function to format sensor values
const formatSensorValue = (
  value: number | undefined,
  isConnected: boolean | undefined
) => {
  if (!isConnected) return "X";
  if (value === undefined || value === null || value === -9999) {
    return "N/A";
  }
  return value.toString();
};

export const DeviceSensorGrid: React.FC<DeviceSensorGridProps> = ({
  shadowData,
}) => {
  // Check if any alarm is present (alarms > 0)
  const hasAlarm = shadowData?.alarms !== undefined && shadowData.alarms > 0;

  return (
    <SensorGridContainer $hasAlarm={hasAlarm}>
      <SensorCell connected={!!shadowData?.salinityConnected}>
        <SensorLabel>Salt</SensorLabel>
        <SensorValue>
          {formatSensorValue(
            shadowData?.salinity,
            shadowData?.salinityConnected
          )}
        </SensorValue>
      </SensorCell>

      <SensorCell connected={!!shadowData?.tempConnected}>
        <SensorLabel>Temp</SensorLabel>
        <SensorValue>
          {formatSensorValue(shadowData?.temp, shadowData?.tempConnected)}
        </SensorValue>
      </SensorCell>

      <SensorCell connected={!!shadowData?.orpConnected}>
        <SensorLabel>ORP</SensorLabel>
        <SensorValue>
          {formatSensorValue(shadowData?.orp, shadowData?.orpConnected)}
        </SensorValue>
      </SensorCell>

      <SensorCell connected={!!shadowData?.phConnected}>
        <SensorLabel>pH</SensorLabel>
        <SensorValue>
          {formatSensorValue(shadowData?.ph, shadowData?.phConnected)}
        </SensorValue>
      </SensorCell>
    </SensorGridContainer>
  );
};

